"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateWidgetsService = void 0;
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var widgets_1 = require("@wix/wix-vod-api-site-based/dist/src/private/services/widgets/widgets");
var to_error_1 = require("../../parsers/to-error");
var PrivateWidgetsService = /** @class */ (function () {
    function PrivateWidgetsService(httpClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.updateWidgetSettings = function (widgetId, settings) {
            return _this.privateWidgetsService
                .updateSettings(widgetId, (0, object_1.keysToSnakeCase)(settings))
                .then(function (response) { return (0, object_1.keysToCamelCase)(response.data); })
                .catch(to_error_1.toError);
        };
        this.updateWidget = function (widgetId, widgetMetadata) {
            return _this.privateWidgetsService
                .create(widgetId, (0, object_1.keysToSnakeCase)(widgetMetadata))
                .then(function (response) {
                return (0, object_1.keysToCamelCase)(response.data);
            })
                .catch(to_error_1.toError);
        };
        this.privateWidgetsService = new widgets_1.PrivateWidgets(httpClient);
    }
    return PrivateWidgetsService;
}());
exports.PrivateWidgetsService = PrivateWidgetsService;
//# sourceMappingURL=widgets.js.map